import { useTranslation } from 'react-i18next'
import { calcDailyNumber, getDailyText, isMaster } from '@yadviga/shared'
import { useSession } from '../../store/user.store'
import { PageHeader } from '../../components/ui/PageHeader'
import { Button } from '../../components/ui/Button'
import { MarkdownText } from '../../components/ui/Markdown'

export function NumbersDayRoute() {
  const { t } = useTranslation()
  const user = useSession((s) => s.user)
  const lang = (user?.language ?? 'ru') as 'ru' | 'en'

  if (!user?.birthDate) return <NoBirthDate />

  const num = calcDailyNumber(user.birthDate)
  const text = getDailyText(num, lang)
  const today = new Date().toLocaleDateString(lang === 'en' ? 'en-US' : 'ru-RU', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  })

  return (
    <div className="flex flex-col gap-5 pb-6">
      <PageHeader title={t('numbers.day_title')} backTo="/numbers" />
      <div className="flex flex-col items-center gap-2 rounded-3xl bg-gradient-to-b from-white/80 to-cream/40 p-6 text-center ring-1 ring-sage-200/60">
        <span className="text-xs uppercase tracking-wider text-sage-500">{today}</span>
        <div className="font-serif text-7xl text-copper leading-none">{num}</div>
        {isMaster(num) && (
          <span className="mt-1 rounded-full bg-copper/15 px-3 py-0.5 text-[10px] uppercase tracking-wider text-copper">
            {t('numbers.master_number')}
          </span>
        )}
      </div>
      <div className="rounded-3xl bg-white/60 p-5 ring-1 ring-sage-200/60">
        <MarkdownText>{text}</MarkdownText>
      </div>
    </div>
  )
}

function NoBirthDate() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center gap-4 py-10 text-center text-sage-700">
      <PageHeader title={t('numbers.day_title')} backTo="/numbers" />
      <p>{t('numbers.no_birth_date')}</p>
      <Button onClick={() => (window.location.href = '/profile')}>
        {t('numbers.add_birth_date')}
      </Button>
    </div>
  )
}
